import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Row, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { FC, useEffect } from "react";
import MainCreateShipping from "../CreateShipping/MainCreateShipping";
import {
  useGetTransportationConfigs,
  useGetTransportationTypeByFactory,
} from "hooks/useFactory";
import UpdateShippingFooter from "./UpdateShippingFooter";
import { useUpdateTransportationConfigs } from "hooks/useOrders";
import {
  LoadTransportationItem,
  UpdateTransportationInput,
} from "services/interface";
import { useGetMasterGeography } from "hooks/useMasterData";
import { useAppSelector } from "store";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
};
interface UpdateShippingProps {
  geography_id: string;
  transport_type: string;
  province_id: string | undefined;
  district_id: string | undefined;
  is_free: boolean;
}
const UpdateShipping: FC<UpdateShippingProps> = ({
  geography_id,
  transport_type,
  province_id,
  district_id,
  is_free,
}) => {
  const navigate = useNavigate();
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );
  const { data: dataTransportation } = useGetTransportationTypeByFactory(
    factoryId ?? ""
  );
  const { data: transportationConfigsData } = useGetTransportationConfigs({
    geography_id: parseInt(geography_id),
    transport_type: transport_type,
    province_id: province_id ? parseInt(province_id) : null,
    district_id: district_id ? parseInt(district_id) : null,
  });
  const { mutate: UpdateTransportationConfigs } =
    useUpdateTransportationConfigs();
  const [form] = Form.useForm();
  const { data: dataGeography } = useGetMasterGeography();

  useEffect(() => {
    //console.log(transportationConfigsData?.data);

    const sort = transportationConfigsData?.data[0]?.items.sort(
      (a: LoadTransportationItem, b: LoadTransportationItem) => {
        return a.transport_rate - b.transport_rate;
      }
    );

    //filter more_then
    const more_then = sort?.filter((item: LoadTransportationItem) => {
      if (item.condition_config === "more_then") {
        return {
          totalPrice: item.transport_rate,
          transportPrice: item.service_price,
        };
      }
    });

    //filter more_then out
    const more_then_without = sort?.filter((item: LoadTransportationItem) => {
      if (item.condition_config === "less") {
        return {
          totalPrice: item.transport_rate,
          transportPrice: item.service_price,
        };
      }
    });

    const less = more_then_without?.map((item: LoadTransportationItem) => {
      return {
        totalPrice: item.transport_rate,
        transportPrice: item.service_price,
      };
    });

    //console.log(less);

    if (transportationConfigsData) {
      form.setFieldsValue({
        geolocation_key:
          transportationConfigsData?.data[0]?.geography_id === 7
            ? undefined
            : transportationConfigsData?.data[0]?.geography_id,
        transportation_key: transportationConfigsData?.data[0]?.transport_type,
        transportRate: less,
        more_then_service_price: more_then?.[0]?.service_price,
        remark: transportationConfigsData?.data[0]?.remark,
      });

      
      if (province_id !== null) {
  
        form.setFieldsValue({
          geolocation_type:
            transportationConfigsData?.data[0]?.geography_id === 7
              ? "all"
              : transportationConfigsData?.data[0]?.geography_id === null
              ? "province"
              : "geolocation",
        });
      } else {
        form.setFieldsValue({
          geolocation_type: "province",
        });
      }
    }
  }, [transportationConfigsData, province_id]);

  // form.setFieldsValue({
  //   geolocation_type: "province",
  // });

  const onFinish = (values: any) => {
    console.log("values", values);

    let pricelist: any[] = []

    if (values.free_shipping !== true) {
      pricelist = values.transportRate?.map((item: any) => {
        return {
          condition_config: "less",
          transport_rate: item.totalPrice,
          service_price: item.transportPrice,
        };
      }) || [];
    } else {
      pricelist = [
        {
          condition_config: "less",
          transport_rate: 0,
          service_price: 0,
        },
      ];
    }

    // ตรวจสอบว่า transportRate มีข้อมูลหรือไม่
    const lastTransportRate = values?.transportRate && values.transportRate.length > 0 
      ? values.transportRate[values.transportRate.length - 1]?.totalPrice || 0
      : 0;

    const dataRaw: UpdateTransportationInput = {
      factoty_id: factoryId ?? "",
      is_free: values.free_shipping,
      geography_id: parseInt(geography_id),
      remark: values.remark,
      transport_type: values.transportation_key,
      province_id: province_id ? parseInt(province_id) : null,
      district_id: district_id ? parseInt(district_id) : null,
      price_list: [
        ...pricelist,
        {
          condition_config: "more_then",
          transport_rate: lastTransportRate,
          service_price: values?.more_then_service_price || 0,
        },
      ],
    };

    console.log("dataRaw", dataRaw);

    UpdateTransportationConfigs(dataRaw, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("แก้ไขค่าจัดส่งสำเร็จ");
          navigate(`/manage-shipping`);
        } else {
          message.error(`แก้ไขค่าจัดส่งไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`แก้ไขค่าจัดส่งไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      initialValues={
        {
          // transportRate: [{ totalPrice: "", transportPrice: "" }],
        }
      }
    >
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/manage-shipping");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>แก้ไขค่าจัดส่ง</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <Row>
                <Col sm={0} md={6}></Col>
                <Col sm={24} md={12}>
                  <MainCreateShipping
                    data={dataTransportation?.data}
                    form={form}
                    dataGeography={dataGeography}
                    edit={true}
                    province_id={province_id ? parseInt(province_id) : null}
                    district_id={district_id ? parseInt(district_id) : null}
                    is_free={is_free}
                  />
                </Col>
                <Col sm={0} md={6}></Col>
              </Row>
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <UpdateShippingFooter />
    </Form>
  );
};

export default UpdateShipping;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
